export default {
	getDictionary(params, key, bc) {//获取			
		let _this = this, localName;
		// if(!this[key].length){
		let postData = {};
		if (params instanceof Object) {
			for (let k in params) {
				if (k == "url") {
					postData[k] = params[k];
					localName = params[k];
				} else {
					if (!postData.params) {
						postData.params = {}
					}
					postData.params[k] = params[k];
				}
			}
		} else {
			postData = { url: params }
			localName = params;
		};
		let D = localStorage.getItem(localName);
		if (params instanceof Object && !params.cache) {
			goactionPost();
		} else if (D) {
			if (typeof bc == "function") {
				bc(JSON.parse(D), key);
			} else {
				_this[key] = JSON.parse(D).data;
			}
		} else {
			goactionPost();
		}
		function goactionPost() {
			_this.actionPost(postData, function (data) {
				localStorage.setItem(localName, JSON.stringify(data));
				if (typeof bc == "function") {
					bc(data, key);
				} else {
					_this[key] = data.data;
				}
			})
		}
		// }
	},
	actionPost(o, bc, errorFn) {//通用请求
		var _this = this, localName = o.url;
		let BD = localStorage.getItem(localName);
		if (o.cache && BD) {
			if (typeof bc === "function") {
				bc(JSON.parse(BD));
			} else {
				this.$message.success('操作成功！')
				this.fetch();
			}
			return new Promise((resolve, reject) => {
				resolve(JSON.parse(BD));
			})
		} else {
			var a = axios({
				url: P.ajaxUrl + o.url,
				data: o.params ? o.params : {},
				method: 'post',
				type: 'json',
			}).then((data) => {
				let D = data.data;
				//更新表格
				if (D.resultCode == 0) {
					if (o.cache) { localStorage.setItem(localName, JSON.stringify(D)) };
					if (typeof bc === "function") {
						bc(D);
					} else {
						_this.$message.success('操作成功！')
						_this.fetch();
					}
				} else {
					if (errorFn) errorFn(D);
					_this.$error({
						title: '错误提示！',
						content: D.resultMessage,
					});
				}
			}).catch((e) => {
				console.log('actionPost-error', e);
			});
			return a;
		}
	},
	hasAuthority(name) {
		let Authoritys = U.userOptAuthority;
		if (Authoritys && Authoritys.length) {
			let has = false;
			Authoritys.forEach(function (v, i) {
				if (v.routerName == name) {
					has = true;
				}
			});
			return has;
		} else {
			return true;
		}
	}
}



// WEBPACK FOOTER //
// ./src/public/methods.js